module.exports = __webpack_public_path__ + "img/logo-menu.b17002cf.svg";